import { render, staticRenderFns } from "./SearchFocus.vue?vue&type=template&id=1bcaff7f&scoped=true&"
import script from "./SearchFocus.vue?vue&type=script&lang=js&"
export * from "./SearchFocus.vue?vue&type=script&lang=js&"
import style0 from "./SearchFocus.vue?vue&type=style&index=0&id=1bcaff7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcaff7f",
  null
  
)

export default component.exports